const timeoutWeakmap = new WeakMap();

const TimeoutServiceClass = class {
  add(instance, ...tIds) {
    if (!timeoutWeakmap.has(instance)) {
      timeoutWeakmap.set(instance, []);
    }

    timeoutWeakmap.set(instance, timeoutWeakmap.get(instance).concat(...tIds));
  }

  clear(instance) {
    if (timeoutWeakmap.has(instance)) {
      timeoutWeakmap.get(instance).forEach(clearTimeout);
      timeoutWeakmap.delete(instance);
    }
  }

  remove(instance, tId) {
    if (timeoutWeakmap.has(instance)) {
      clearTimeout(tId);
      timeoutWeakmap.set(
        instance,
        timeoutWeakmap.get(instance).filter((id) => id !== tId),
      );
    }
  }
};

export const TimeoutService = new TimeoutServiceClass();
